import { useState } from 'react';
import styled from 'styled-components';
import DefaultInput from 'components/input/DefaultInput';

import { color } from 'asserts/styles/colors';

interface EditDataProps {
  accountData: any;
  setNewData: (newData: string) => void;
  onChangeData: () => void;
}

const AccountEdit = ({ accountData, setNewData, onChangeData }: EditDataProps) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [editNewData, setEditNewData] = useState(accountData);
  const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { value, name } = e.currentTarget;
    setEditNewData({ ...editNewData, [name]: value });
  };

  const handleClick = () => {
    setIsEditMode((prev) => !prev);
  };

  const handleSave = () => {
    setNewData(editNewData);
    setIsEditMode(false);

    setTimeout(() => {
      onChangeData();
    }, 0);
  };

  return (
    <Wrapper>
      <TextWrapper $isSaveName={isEditMode}>
        {isEditMode ? (
          <InfoWrapper>
            <DefaultInput name="bank" onChange={handleChange} placeholder="은행명" />

            <DefaultInput name="depositor" onChange={handleChange} placeholder="성함" />

            <DefaultInput name="account" onChange={handleChange} placeholder="계좌번호" />
          </InfoWrapper>
        ) : (
          <InfoWrapper>
            <h6>{accountData.bank}</h6>
            <h6>{accountData.depositor}</h6>
            <h6>{accountData.account}</h6>
          </InfoWrapper>
        )}
      </TextWrapper>
      <div>
        {isEditMode ? (
          <ButtonWrapper>
            <button onClick={() => handleSave()}>저장</button>
            <button className="cancel" onClick={handleClick}>
              취소
            </button>
          </ButtonWrapper>
        ) : (
          <ParentWrapper><button onClick={handleClick}>수정</button> <SimpleTextWrapper>'수정'을 클릭하면 수정 할 수 있습니다.</SimpleTextWrapper></ParentWrapper>
        )}
      </div>
    </Wrapper>
  );
};

export default AccountEdit;

const Wrapper = styled.div`
  display: flex;
  gap: 16px;

  div {
    display: flex;
  }

  button {
    color: ${color.black2};
    font-weight: 500;
  }
`;

const TextWrapper = styled.div<{ $isSaveName: boolean }>`
  display: flex;
  height: 36px;
  border-radius: 4px;
  align-items: center;
  justify-content: center;

  input {
    width: 120px;
  }

  h6 {
    display: flex;
    width: 180px;
    height: 36px;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 18px;
    border: 1px solid rgba(12, 12, 12, 0.05);
    border-radius: 4px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 25px;

  button.cancel {
    position: relative;
    color: ${color.gray500};

    &::after {
      content: '';
      display: inline-block;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: -50%;
      width: 1px;
      height: 12px;
      background: ${color.gray300};
    }
  }
`;

const InfoWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

const ParentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
`;

const SimpleTextWrapper = styled.p`
  display: flex;
  align-items: center;
  color: ${color.blue500};
  gap: 30px;
`;